module.exports = __webpack_public_path__ + "static/img/wlwcp4.9a0a55a2.png";